import { useCallback, useContext } from 'react'
import { AppContext, AppContextType, SnackbarSeverityType } from '../AppContext'

function useRootSnackbar() {
    const { dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const show = useCallback(
        (value: { severity: SnackbarSeverityType; message: string; duration?: number }) => {
            appDispatch({
                type: 'root_snackbar_history_append',
                value: value,
            })
        },
        [appDispatch]
    )

    return {
        show,
    }
}

export default useRootSnackbar
